import { useState } from "react";
import "primeflex/primeflex.css";
import Services from "../service/ApiServices"
import _ from "lodash";

export const useStaffService = (formik = null)=>{
    const [filteredStaff, setFilteredStaff] = useState([]);  
  

    const SearchStaff = (event)=>{setTimeout(async () => {
        let _filteredStaff;
        if (!event.query.trim().length) {
            _filteredStaff = [];
        }
        else {            
            _filteredStaff = (await Services.Setup.getStaff(event.query.toLowerCase())).data
            if(formik && _.get(formik.values, "model")){
                _.forEach(formik.values.model.bedMngmtStaffDetails, (value)=> {
                    _filteredStaff = _filteredStaff.filter(s=> s.id !== value.id)                   
                });
            }
        }
        setFilteredStaff(_filteredStaff);
    }, 250)};

    const GetInheritedStaff = async (parentType, parentId)=>{
        const inheritedStaff = (await Services.Setup.getInheritedStaff(parentType, parentId));
        return inheritedStaff.data;
    }

    return   {filteredStaff, SearchStaff, GetInheritedStaff}
}


